module.exports = __webpack_public_path__ + "img/refresh.7adbd5e3.svg";